import { css } from '@emotion/css';
import React from 'react';
import { LaunchDarklyIcon } from './LaunchDarklyIcon';
import { theme } from '../theme';
const containerStyles = css({
    position: 'absolute',
    bottom: '60px',
    right: '0px',
    width: '50px',
    height: '50px',
    padding: '5px',
    overflow: 'hidden',
    '&:hover': {
        button: {
            transform: 'translateX(0px)',
        },
    },
});
const buttonStyles = css({
    borderRadius: '6px',
    backgroundColor: theme.colors.midBlue,
    border: 'none',
    padding: '10px',
    transition: 'transform 200ms ease-in-out',
    transform: 'translateX(45px)',
    width: '100%',
    cursor: 'pointer',
});
const FloatingButton = ({ onClick }) => (React.createElement("div", { className: containerStyles },
    React.createElement("button", { type: "button", className: buttonStyles, onClick: onClick },
        React.createElement(LaunchDarklyIcon, null))));
export { FloatingButton };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmxvYXRpbmdCdXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9GbG9hdGluZ0J1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUNuQyxPQUFPLEtBQWEsTUFBTSxPQUFPLENBQUM7QUFDbEMsT0FBTyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sb0JBQW9CLENBQUM7QUFDdEQsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUVqQyxNQUFNLGVBQWUsR0FBRyxHQUFHLENBQUM7SUFDMUIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsTUFBTSxFQUFFLE1BQU07SUFDZCxLQUFLLEVBQUUsS0FBSztJQUNaLEtBQUssRUFBRSxNQUFNO0lBQ2IsTUFBTSxFQUFFLE1BQU07SUFDZCxPQUFPLEVBQUUsS0FBSztJQUNkLFFBQVEsRUFBRSxRQUFRO0lBQ2xCLFNBQVMsRUFBRTtRQUNULE1BQU0sRUFBRTtZQUNOLFNBQVMsRUFBRSxpQkFBaUI7U0FDN0I7S0FDRjtDQUNGLENBQUMsQ0FBQztBQUVILE1BQU0sWUFBWSxHQUFHLEdBQUcsQ0FBQztJQUN2QixZQUFZLEVBQUUsS0FBSztJQUNuQixlQUFlLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPO0lBQ3JDLE1BQU0sRUFBRSxNQUFNO0lBQ2QsT0FBTyxFQUFFLE1BQU07SUFDZixVQUFVLEVBQUUsNkJBQTZCO0lBQ3pDLFNBQVMsRUFBRSxrQkFBa0I7SUFDN0IsS0FBSyxFQUFFLE1BQU07SUFDYixNQUFNLEVBQUUsU0FBUztDQUNsQixDQUFDLENBQUM7QUFNSCxNQUFNLGNBQWMsR0FBMkIsQ0FBQyxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUM5RCw2QkFBSyxTQUFTLEVBQUUsZUFBZTtJQUM3QixnQ0FBUSxJQUFJLEVBQUMsUUFBUSxFQUFDLFNBQVMsRUFBRSxZQUFZLEVBQUUsT0FBTyxFQUFFLE9BQU87UUFDN0Qsb0JBQUMsZ0JBQWdCLE9BQUcsQ0FDYixDQUNMLENBQ1AsQ0FBQztBQUVGLE9BQU8sRUFBRSxjQUFjLEVBQUUsQ0FBQyJ9